import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, delay, from, of, switchMap } from 'rxjs';


import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserAuthServiceService } from './models/user-auth.service';



@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandlerInterceptorService implements HttpInterceptor {

  constructor(private toastrService: ToastrService, private authService: UserAuthServiceService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      catchError(error => {
        let errorMessage = "Beklenmeyen bir hata meydana geldi.";

        if (error.error?.message) {
          errorMessage = error.error.message; // API'den gelen hata mesajı varsa onu kullan
        }

        switch (error.status) {
          case HttpStatusCode.Unauthorized: // 401
            this.toastrService.error(errorMessage, "Yetkisiz Erişim!");
            this.router.navigate(['/admin/deneme']);
            break;
          case HttpStatusCode.Forbidden: // 403
            this.toastrService.error("Bu işlem için yetkiniz yok.", "Erişim Engellendi!");
            break;
          case HttpStatusCode.InternalServerError: // 500
            this.toastrService.error("Sunucuya erişilemiyor. Lütfen tekrar deneyiniz.", "Sunucu Hatası!");
            break;
          case HttpStatusCode.NoContent: // 204
            this.toastrService.warning("İçerik boş olamaz.", "Uyarı!");
            break;
          case HttpStatusCode.BadRequest: // 400
            this.toastrService.warning(errorMessage, "Geçersiz İstek!");
            break;
          case HttpStatusCode.NotFound: // 404
            this.toastrService.error("İlgili sayfa veya içerik bulunamadı.", "Sayfa Bulunamadı!");
            break;
          default:
            this.toastrService.error(errorMessage, "Hata!");
            break;
        }

        return of(error);
      })
    );
  }
}
